var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "label",
        {
          staticClass: "m-auto mr-2 ml-0",
          attrs: {
            for: _vm.$attrs.id
              ? _vm.$attrs.id
              : _vm.$fid("vspaginationlengthcustom"),
          },
        },
        [_vm._v(_vm._s(_vm.title))]
      ),
      _vm._v(" "),
      _c(
        "vs-dropdown",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tableProvider && _vm.tableProvider.pageLengths,
              expression: "tableProvider && tableProvider.pageLengths",
            },
          ],
          ref: "dropdown",
          class: [
            {
              "cursor-pointer":
                !_vm.backendOcupado &&
                (!_vm.tableProvider || !_vm.tableProvider.busy),
            },
            {
              "cursor-not-allowed":
                _vm.backendOcupado ||
                (_vm.tableProvider ? _vm.tableProvider.busy : false),
            },
            {
              disabled:
                _vm.backendOcupado ||
                (_vm.tableProvider ? _vm.tableProvider.busy : false),
            },
          ],
          attrs: {
            id: _vm.$attrs.id
              ? _vm.$attrs.id
              : _vm.$fid("vspaginationlengthcustom"),
            "vs-trigger-click": "",
            disabled:
              _vm.backendOcupado ||
              (_vm.tableProvider ? _vm.tableProvider.busy : false),
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "p-3 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium",
            },
            [
              _c("span", { staticClass: "mr-2" }, [
                _vm._v(
                  _vm._s(
                    _vm.tableProvider
                      ? _vm.tableProvider.state.perPage == -1
                        ? "Todos de " + _vm.tableProvider.totalRows
                        : _vm.tableProvider.startRow > _vm.tableProvider.endRow
                        ? _vm.tableProvider.endRow
                        : _vm.tableProvider.startRow +
                          " - " +
                          _vm.tableProvider.endRow +
                          " de " +
                          _vm.tableProvider.totalRows
                      : ""
                  )
                ),
              ]),
              _vm._v(" "),
              _c("feather-icon", {
                attrs: { icon: "ChevronDownIcon", svgClasses: "h-4 w-4" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "vs-dropdown-menu",
            {
              class:
                "con-vs-dropdown--menu vs-dropdown-menu " + _vm.dropdownClass,
            },
            _vm._l(_vm.tableProvider.pageLengths, function (option, index) {
              return _c(
                "vs-dropdown-item",
                {
                  key: index,
                  class: [
                    {
                      "bg-primary text-white":
                        _vm.tableProvider.state.perPage == option.value,
                    },
                  ],
                  attrs: {
                    disabled:
                      _vm.backendOcupado ||
                      (_vm.tableProvider ? _vm.tableProvider.busy : false),
                  },
                  on: {
                    click: function ($event) {
                      _vm.$refs.dropdown.$el.click()
                      _vm.tableProvider.state.perPage = option.value
                    },
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(option.text == "All" ? "Todos" : option.text)
                    ),
                  ]),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }